module.exports = __webpack_public_path__ + "img/temp-bg-mobile.7a0db037.jpg";